import {
	ADMINMODULEALLOCATION_SUCCESS,
	ADMINMODULEALLOCATION_FAILED,
	RESET_ADMINMODULEALLOCATION,
	LOADING_ADMINMODULEALLOCATION,
	NETWORK_ERROR_ADMINMODULEALLOCATION
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINMODULEALLOCATION:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINMODULEALLOCATION_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINMODULEALLOCATION_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINMODULEALLOCATION:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINMODULEALLOCATION:
			return (state = initialState);
		default:
			return state;
	}
};
